<template>
  <v-container v-if="loaded">
    <v-row no-gutters>
      <v-col
        class="offset-md-1"
        sm="12"
        md="10">
        <v-card
          flat
          class="cancelMeeting">
          <v-card-text
            v-if="!canceled"
            class="pa-0">
            <v-row
              no-gutters
              wrap
              mx-2>
              <v-col
                cols="12"
                sm="12"
                class="text-center my-3">
                <h1
                  :class="!isEmbedded ? 'display-1 black--text text-center font-weight-medium mb-0' : 'black--text text-center font-weight-medium subtitle-1 mb-0'">
                  <span class="red--text font-weight-black">{{ $t('cancel.title') }} </span>{{ meeting.meetingTitle }}
                </h1>
                <v-col
                  cols="12"
                  class="pa-3 body-1 text-center">
                  {{ $t('cancel.reason') }}
                </v-col>
              </v-col>
            </v-row>

            <v-row
              :class="isEmbedded ? 'cancelMeeting__content ma-4' : 'cancelMeeting__content'"
              class="border--radius-box"
              no-gutters>
              <!-- Header Info Component -->
              <v-col
                cols="12"
              >
                <meeting-header-info
                  :location="meeting.location"
                  :duration="duration"
                  :host-picture="host.pictureUrl"
                  :host-name="host.fullName"
                  :is-embedded="isEmbedded"/>
              </v-col>
              <v-col
                cols="12"
                class="text-center">
                <v-divider/>
                <v-row
                  no-gutters
                  justify="center"
                  class="pa-7">
                  <v-card
                    flat
                    class="d-flex justify-center">
                    <v-img
                      width="80px"
                      height="80px"
                      contain
                      src="/assets/calendar.png"
                      class="justify-center"/></v-card>
                  <v-card-text class="subtitle-1 black--text font-weight-bold text-center">
                    {{ meeting.meetingTitle }}
                    <span class="font-weight-regular"> with </span>
                    {{ host.fullName }}

                    <v-col
                      cols="12"
                      class="title text-center pa-0">
                      {{ meetingStartDate.format('D') }}<sup>{{ getNth(meetingStartDate.format('D')) }}</sup>
                      {{ meetingStartDate.format(' MMMM YYYY, ') }} {{ formatHour(meetingStartDate, meeting.timezone) }} - {{ formatHour(meetingEndDate, meeting.timezone, true) }}
                      {{ meeting.timezone }}
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                      max-width="400px"
                      class="pa-3 body-1 text-center offset-md-3">
                      <v-row
                        no-gutters
                        justify="center">
                        <v-col cols="12">
                          <v-textarea
                            v-model="cancelReason"
                            :label="$t('cancel.message')"
                            :rules="cancelReasonRules"
                            filled
                            height="120px"
                            hide-details
                          />
                        </v-col>
                        <v-col cols="12">
                          <v-btn
                            :loading="isCanceling"
                            x-large
                            class="secondary mt-4 mb-2 capitalize--text"
                            color="white"
                            @click.native="cancel">{{ $t('cancel.confirm') }}
                          </v-btn>
                        </v-col>
                        <v-col
                          cols="12"
                          class="mt-2">
                          <a
                            class="subtitle-1 font-weight-medium"
                            @click="goToReschedule()">{{ $t('cancel.reschedule') }}</a>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- Meeting Canceled Page -->
          <v-card-text
            v-if="canceled"
            class="pa-0">
            <v-row
              no-gutters
              wrap
              mx-2>
              <v-col
                cols="12"
                xs="12"
                class="pa-3 mb-3">
                <h3
                  :class="!isEmbedded ? 'headline red--text text-center font-weight-medium mb-2' : 'red--text text-center font-weight-medium subtitle mb-0'">
                  {{ $t('cancel.canceledMeeting') }}
                </h3>
                <div
                  :class="!isEmbedded ? 'body-1 text-center grey--text text--darken-3' : 'body-2 text-center grey--text darken-3'"
                  cols="12">
                  {{ $t('cancel.notified', { email: meeting.email }) }}</div>
              </v-col>

              <v-row
                no-gutters
                class="cancelMeeting__content">
                <!-- Header Info Component -->
                <v-col
                  cols="12"
                >
                  <meeting-header-info
                    :location="meeting.location"
                    :duration="duration"
                    :host-picture="host.pictureUrl"
                    :host-name="host.fullName"
                    :is-embedded="isEmbedded"/>
                  <v-divider/>
                </v-col>
                <v-row
                  no-gutters
                  class=" pa-7">
                  <v-col
                    cols="12"
                    xs="12"
                    justify="center"
                    class="text-center"
                  >
                    <v-card
                      flat
                      class="d-flex justify-center">
                      <v-img
                        width="80px"
                        height="80px"
                        contain
                        src="/assets/calendar.png"
                        class="justify-center"/></v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    class="body-1 text-center pa-3">
                    <v-card-text class="subtitle-1 black--text font-weight-bold text-center">
                      <span class="red--text">{{ $t('cancel.canceled') }}</span>
                      {{ meeting.meetingTitle }}
                      <span class="font-weight-regular"> with </span>
                      {{ host.fullName }}

                      <v-col
                        cols="12"
                        class="title text-center pa-0">
                        {{ meetingStartDate.format('D') }}<sup>{{ getNth(meetingStartDate.format('D')) }}</sup>
                        {{ meetingStartDate.format(' MMMM YYYY, ') }}{{ formatHour(meetingStartDate, meeting.timezone) }} - {{ formatHour(meetingEndDate, meeting.timezone, true) }}
                        {{ meeting.timezone }}
                      </v-col>
                    </v-card-text>
                    <v-btn
                      v-if="!settings || !settings.whiteLabel"
                      color="primary"
                      rounded
                      x-large
                      class="capitalize--text font-weight-bold subtitle-1"
                      @click.native="installGmelius">
                      <v-img
                        src="/assets/logo/logoGoogle.png"
                        height="24px"
                        width="24px"
                        class="mr-3"/>
                      <span>
                        {{ $t('booked.installGmelius') }}
                      </span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    class="body-1 text-center pa-3 caption offset-md-3">
                    <a
                      class="subtitle-1 font-weight-medium"
                      @click="goToLandingPage">{{ $t('booked.schedule') }}</a>

                  </v-col>
                </v-row>
              </v-row>
            </v-row>
          </v-card-text>
          <powered-by
            :display-text="!settings || !settings.whiteLabel"/>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      :timeout="10000"
      left>
      {{ $t('snackBar.cancel') }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { localeMixin, snackbarMixin } from '../mixins'
import moment from 'moment'
import momentTz from 'moment-timezone'
import PoweredBy from './PoweredBy.vue'
import { externalLinks } from '../config'
import { nth } from '../modules/utils'
import MeetingHeaderInfo from './MeetingHeaderInfo.vue'

export default {

  components: {
    PoweredBy,
    MeetingHeaderInfo
  },
  mixins: [localeMixin, snackbarMixin],
  data () {
    return {
      canceled: false,
      cancelReason: '',
      comingFromBooked: false,
      duration: 0,
      isCanceling: false,
      isEmbedded: null,
      loaded: false,
      meeting: null,
      meetingStartDate: null,
      meetingEndDate: null,
      snackbar: true,
      settings: null,
      cancelReasonRules: [
        v => v.length <= 1000 || this.$t('cancel.reasonTooLong')
      ]
    }
  },
  watch: {
    windowWidth (newHeight, oldHeight) {
      this.isEmbedded = newHeight < 500 ? '1' : null
    }
  },
  async mounted () {
    this.$router.push({ name: 'home' })
    return
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateScreenSize)
  },
  methods: {
    updateScreenSize (newWidth) {
      this.windowWidth = newWidth
    },
    async cancel () {
      try {
        this.snackbar = false
        this.isCanceling = true
        const body = {
          inv: this.$route.query.i,
          startTS: this.$route.query.s,
          endTS: this.$route.query.e,
          cancelReason: this.cancelReason,
          secret: this.$route.query.sec
        }
        const payload = { meetingIdEnc: this.$route.query.m, body }
        await this.$store.dispatch('meetings/cancelMeeting', payload)
        this.canceled = true
      } catch (err) {
        console.log(err)
        this.openSnackbarError()
      }
      this.isCanceling = false
    },
    getNth (date) {
      return nth(date)
    },
    goToLandingPage () {
      this.$router.replace({ query: { } })
      this.$router.push({
        name: 'meeting',
        params: {
          prefixMeetingUrl: this.$route.params.prefixMeetingUrl,
          meetingTypeUrl: this.$route.params.meetingTypeUrl
        }
      })
    },
    goToReschedule () {
      this.$router.push({ name: 'reschedule',
        params: {
          prefixMeetingUrl: this.$route.params.prefixMeetingUrl,
          meetingTypeUrl: this.$route.params.meetingTypeUrl
        },
        query: this.$route.query })
    },
    goBack () {
      this.$router.go(-1)
    },
    installGmelius () {
      window.open(externalLinks.dashboardUrl, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.cancelMeeting {
  &__content{
    border: 1px solid #dedede;
  }
}
</style>
